<template>
  <div class="contract">
    <CCard class="card-table-emloyee">
      <CRow>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("employee.label_employee_request_search_code_name") }}</label>
            <CInput
              v-model="searchData.name"
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="1" class="text-center btn-search">
          <CButton class="btn-search-employee" @click.prevent="search()">
            {{ $t("button.label_employee_btn_search") }}
          </CButton>
        </CCol>
        <CCol sm="1" class="text-center btn-search">
          <CButton class="btn-reset" @click="resetForm()">
            {{ $t("button.label_action_reset") }}
          </CButton>
        </CCol>
      </CRow>
    </CCard>
    <CRow>
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody>
            <CRow class="justify-content-end p-2">
              <router-link
                class="btn btn-info"
                :to="{ path: `/employees/additional-days-off` }"
                >
                  {{ $t("employee.import") }}
                </router-link
              >
              <CButton color="warning ml-3" @click="exportData">Export</CButton>
            </CRow>
            <div class="table-responsive">
              <table class="table employee-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th
                      @click="sortByColumn(columnSort.id)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_employee_code") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort(columnSort.id)"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      @click="sortByColumn(columnSort.name)"
                      class="cl-pointer"
                    >
                      {{ $t("employee.label_employee_name") }}
                      <span class="icon-sort">
                        <CIcon
                          name="cil-caret-bottom"
                          :class="classStatusSort(columnSort.name)"
                        ></CIcon>
                      </span>
                    </th>
                    <th
                      scope="col"
                      style="text-align: center"
                    >
                      {{ $t("employee.days_off") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="employees.data && employees.data.length > 0">
                    <tr v-for="(item, index) in employees.data" :key="index">
                      <th scope="row">
                        {{
                          (employees.current_page - 1) * employees.per_page +
                            index +
                            1
                        }}
                      </th>
                      <td>{{ item.id }}</td>
                      <td>
                        <router-link
                          :to="{
                            name: 'employees.detail',
                            params: { id: item.id }
                          }"
                          tag="a"
                        >
                          {{ item.name }}
                        </router-link>
                      </td>
                      <td style="text-align: center">
                        {{ item.number_of_days_leave }}
                        <span @click="showModalEdit(item.id)" class="btn-edit text-danger">
                          <CIcon name="cilPencil" class="btn-icon" />
                        </span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="12" class="text-center">
                        {{ $t("table.label_data_not_found") }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
          <CPagination
            :activePage.sync="searchData.paginate.currentPage"
            :pages="searchData.paginate.totalPage"
            @update:activePage="changePage"
            size="sm"
            align="center"
          />
        </CCard>
      </CCol>
    </CRow>

    <!--modal note-->
    <template>
      <b-modal ref="modal-edit" hide-footer hide-header>
        <ValidationObserver ref="formResignation" v-slot="{ handleSubmit }">
          <CForm @submit.prevent="handleSubmit(updateNumberOfDaysLeave)">
            <CRow>
              <CCol md="12" class="form-field">
                <label>
                  {{ $t("employee.days_off_change") }}
                  <span class="require">*</span>
                </label>
                <ValidationProvider
                  :rules="{
                    required: true,
                    regex: /^-[0-9.]|^[0-9.]+$/,
                  }"
                  v-slot="{ errors }"
                  :name='$t("employee.days_off")'
                >
                  <b-form-input
                    v-model="formEdit.numberOfDaysLeave"
                  ></b-form-input>
                  <span class="require text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
            </CRow>
            <CRow class="d-flex justify-content-end mr-1">
              <b-button type="submit" class="btn btn-success mt-3">
                {{ $t("employee_level.button.save") }}
              </b-button>
              <span class="mr-2"></span>
              <b-button
                class="mt-3"
                variant="outline-danger"
                @click="hideModalEdit"
                >{{ $t("button.label_action_cancel") }}</b-button
              >
            </CRow>
          </CForm>
        </ValidationObserver>
      </b-modal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import XLSX from "xlsx";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "ListDaysOff",
  metaInfo() {
    return {
      title: this.$t("page_title.page_days_off_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      searchData: {
        name: "",
        itemsPerPage: 100,
        columnSortSelect: "id",
        sortBy: "DESC",
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      },
      formEdit: {
        employeeId: null,
        numberOfDaysLeave: null
      },
      columnSort: {
        id: "id",
        name: "name",
        numberOfDaysLeave: "number_of_days_leave"
      },
      export: true
    };
  },
  computed: {
    ...mapGetters({
      employees: "employee/employees",
      daysOffExport: "employee/daysOffExport",
      listItemsPerPage: "commons/listItemsPerPage",
      sort: "commons/sort",
      pagination: "employee/pagination"
    })
  },
  methods: {
    ...mapActions("employee", ["fetchEmployeeDaysOff", "fetchEmployeeDaysOffExport"]),
    ...mapActions("layout", ["setLoading"]),

    showModalEdit(employeeId) {
      this.$refs["modal-edit"].show();
      this.formEdit.employeeId = employeeId;
    },

    hideModalEdit() {
      this.$refs["modal-edit"].hide();
    },

    async fetchEmployeesData() {
      await this.fetchEmployeeDaysOff({
        optionPage: this.searchData.itemsPerPage,
        currentPage: this.searchData.paginate.currentPage,
        columnSort: this.searchData.columnSortSelect,
        sortBy: this.searchData.sortBy,
        name: this.searchData.name.toLowerCase()
      });
      this.searchData.paginate = this.pagination;
    },

    async search() {
      if (this.$route.fullPath !== "/employees/days-off") {
        this.clearParamUrl();
      }
      this.passParamUrl();
      this.setLoading(true);
      try {
        await this.fetchEmployeesData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },

    resetParams() {
      if (this.$route.fullPath !== "/employees/days-off") {
        this.clearParamUrl();
      }
      this.searchData = {
        name: "",
        itemsPerPage: 100,
        columnSortSelect: "id",
        sortBy: "DESC",
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      };
    },

    resetForm() {
      this.searchData.name = "";
    },

    passParamUrl() {
      this.$router.push({
        name: "employees.days-off",
        query: {
          name: this.checkDataParam(this.searchData.name),
          columnSort: this.checkDataParam(this.searchData.columnSortSelect),
          sortBy: this.checkDataParam(this.searchData.sortBy),
          currentPage: this.checkDataParam(
            this.searchData.paginate.currentPage
          ),
          perPage: this.checkDataParam(this.searchData.itemsPerPage)
        }
      });
    },

    clearParamUrl() {
      this.$router.push({ name: "employees.days-off" });
    },

    sortByColumn(column) {
      if (this.searchData.columnSortSelect != column) {
        this.searchData.sortBy = "DESC";
      }
      this.searchData.columnSortSelect = column;
      this.searchData.sortBy =
        this.searchData.sortBy === "DESC" ? "ASC" : "DESC";
      this.passParamUrl();
      this.fetchEmployeesData();
    },

    classStatusSort(column) {
      return this.searchData.columnSortSelect === column &&
        this.searchData.sortBy === "ASC"
        ? "sort-rotate"
        : "";
    },

    changePage(page) {
      this.passParamUrl();
      this.fetchEmployeesData(this.searchData.itemsPerPage, page);
    },

    checkDataParam(data) {
      return data === 0 || data === "" ? undefined : data;
    },

    async updateNumberOfDaysLeave() {
      this.setLoading(true);
      await this.$store
        .dispatch("employee/updateNumberOfDaysLeave", this.formEdit)
        .then(() => {
          this.setLoading(false);
          this.hideModalEdit();
          this.fetchEmployeesData();
          this.$toast(
            this.$t("popup.employee.label_success_day_off"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
        })
        .catch(() => {
          this.setLoading(false);
          this.hideModalEdit();
          this.fetchEmployeesData();
        });
      this.formEdit = {};
    },

    async exportData() {
      this.setLoading(true);
      await this.$store
        .dispatch("employee/fetchEmployeeDaysOffExport", {
          columnSort: this.searchData.columnSortSelect,
          sortBy: this.searchData.sortBy,
          name: this.searchData.name.toLowerCase(),
          export: this.export
        })
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_popup_export_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
        })
        .catch(() => {
          this.setLoading(false);
        });
      let Heading = [
        [
          "Mã nhân viên",
          "Họ và tên",
          "Số ngày phép nhân viên"
        ]
      ];
      var ws = XLSX.utils.aoa_to_sheet(Heading);
      let dataExport = this.daysOffExport;
      ws = XLSX.utils.sheet_add_json(ws, dataExport, {
        skipHeader: true,
        origin: "A2"
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Chi tiết ngày phép nhân viên");
      XLSX.writeFile(
        wb,
        "Chi tiết ngày phép nhân viên.xlsx"
      );
    }
  },
  created() {
    if (Object.keys(this.$route.query).length !== 0) {
      let params = this.$route.query;
      params.perPage =
        this.listItemsPerPage.includes(parseInt(params.perPage)) &&
        !isNaN(params.perPage)
          ? params.perPage
          : 100;
      params.sortBy = this.sort.includes(params.sortBy)
        ? params.sortBy
        : "DESC";
      this.searchData = {
        name: params.name == undefined ? this.searchData.name : params.name,
        itemsPerPage: params.perPage,
        columnSortSelect: params.columnSort,
        sortBy: params.sortBy,
        paginate: {
          from: params.from,
          to: params.to,
          totalPage: parseInt(params.totalPage),
          path: this.searchData.paginate.path,
          currentPage: parseInt(params.currentPage),
          totalRecord: parseInt(params.totalRecord),
          perPage: parseInt(params.perPage)
        }
      };
    }
    this.fetchEmployeesData();
  },
  watch: {
    $route(to) {
      if (to.fullPath === "/employees") {
        this.resetParams();
        this.fetchEmployeesData();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.require {
  margin-top: 5px;
}

.contract {
  margin: -2rem -30px 0 -30px;

  .btn-search {
    margin-top: 20px;
  }

  .card-table-emloyee {
    padding: 30px;

    .select2-container--default {
      border: 1px solid !important;
      color: #e4e6ea !important;
      border-radius: 4px !important;
    }
  }

  .btn-search-employee {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
  }

  .employee-table {
    .cl-pointer {
      cursor: pointer;
      .icon-sort {
        margin-left: 5px;
        .c-icon {
          width: 12px;
        }
        .sort-rotate {
          transform: rotate(180deg);
        }
      }
    }
  }

  .select-per-page {
    width: 70px;
  }

  .option-table {
    display: flex;
    justify-content: space-between;
  }

  table.table {
    th {
      vertical-align: middle !important;
    }

    td {
      vertical-align: middle !important;

      ul {
        margin-bottom: 0px;
        list-style-type: none;
        padding-left: 0px;

        li {
          text-align: left;
        }
      }

      .btn-edit {
        border: 1px solid #e55353;
        border-radius: 5px;
        padding: 5px;
        margin-left: 20px;
      }
    }
  }
}
</style>
<style>
table .btn {
  min-width: auto;
}

.select2.select2-container {
  width: 100%;
}

.select2-custom .select2-selection {
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  height: calc(1.5em + 0.75rem + 2px);
  display: block;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #d8dbe0;
  color: #768192;
  background-color: #fff;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select2-custom .select2-selection:focus {
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}

th,
td {
  vertical-align: top !important;
}
.contract .btn-search {
  margin-top: 26px !important;
}
</style>
